document.querySelectorAll('.mega-menu__link').forEach(elem => {
    if (elem.textContent.includes('|')) {
        const title = elem.textContent.split('|')[0].replace(/[\n\r]+|[\s]{2,}/g, ' ').trim()
        const img = elem.textContent.split('|')[1].replace(/[\n\r]+|[\s]{2,}/g, ' ').trim()
        elem.innerHTML = `
            <div style="text-align: center;"><img
                src="${img}"
                alt=""
                width=""
                height=""
                style="max-width: 100%; height: auto; margin-bottom: .4rem; border-radius: 3%;">
                </div>
            <div style="text-align: center">
                ${title}
            </div>
        `
        elem.closest('.mega-menu__list').style.gridTemplateColumns = 'repeat(5, minmax(0, 1fr))'
    }
    if (elem.textContent.includes('=')) {
          const title = elem.textContent.split('=')[0].replace(/[\n\r]+|[\s]{2,}/g, ' ').trim()
          if (title.includes("DESCR")){
            real_title = title.split('DESCR',5)[0]
            description = title.split('DESCR',5)[1]
          } else {
            real_title = title
            description = ""
          }
          
          const img = elem.textContent.split('=')[1].replace(/[\n\r]+|[\s]{2,}/g, ' ').trim()
          elem.innerHTML = `
              <img
                  src="${img}"
                  alt=""
                  width="50px"
                  height="50px"
                  style="max-width: 100%; height: auto; margin-bottom: .4rem; border-radius: 10%;">
              <div style="text-align: left; display: inline-block;">
                  ${real_title}
                  <p style="font-size:1.2rem; font-style: italic;margin-top: 0.3rem;">${description}</p>
              </div>
          `
          elem.closest('.mega-menu__list').style.gridTemplateColumns = 'repeat(5, minmax(0, 1fr))'
      }
    if (elem.textContent.includes('#')) {
          const title = elem.textContent.split('#')[0].replace(/[\n\r]+|[\s]{2,}/g, ' ').trim()
          const img = elem.textContent.split('#')[1].replace(/[\n\r]+|[\s]{2,}/g, ' ').trim()
          elem.innerHTML = `
              <img
                  src="${img}"
                  alt=""
                  width="12px"
                  height="12px"
                  style="max-width: 100%; height: auto;">
              <div style="text-align: left; display: inline;">
                  ${title}
              </div>
          `
          elem.closest('.mega-menu__list').style.gridTemplateColumns = 'repeat(5, minmax(0, 1fr))'
      }
})

document.querySelectorAll('.menu-drawer__menu-item').forEach(elem => {
    if (elem.textContent.includes('|')) {
        const title = elem.textContent.split('|')[0].replace(/[\n\r]+|[\s]{2,}/g, ' ').trim()
        const img = elem.textContent.split('|')[1].replace(/[\n\r]+|[\s]{2,}/g, ' ').trim()
        if (title == "Rain cover" || title == "Charging cable" || title == "Laptop bag"){
          elem.innerHTML = `
            <div style="display: inline-block;">
            <div style="text-align: left;">
                <img
                    src="${img}"
                    alt=""
                    width="50px"
                    height="50px"
                    style="max-width: 100%; height: auto; margin-bottom: .4rem; border-radius: 3%;">
                    </div>
                <div style="text-align: left;font-size:1rem;">
                    ${title}
                </div>
            </div>
          `
        } else{
        elem.innerHTML = `
            <div>
            <div style="text-align: center;">
                <img
                    src="${img}"
                    alt=""
                    width=""
                    height=""
                    style="max-width: 100%; height: auto; margin-bottom: .4rem; border-radius: 3%;">
                    </div>
                <div style="text-align: center;font-size:1rem;">
                    ${title}
                </div>
            </div>
        `
        }
    }
    if (elem.textContent.includes('=')) {
          const title = elem.textContent.split('=')[0].replace(/[\n\r]+|[\s]{2,}/g, ' ').trim()
          if (title.includes("DESCR")){
            real_title = title.split('DESCR',5)[0]
            description = title.split('DESCR',5)[1]
          } else {
            real_title = title
            description = ""
          }
          const img = elem.textContent.split('=')[1].replace(/[\n\r]+|[\s]{2,}/g, ' ').trim()
          if (title.includes("BUSINESS") || title.includes("COMMUTE") || title.includes("TRAVEL")) {
            elem.innerHTML = `
              <div style="width:auto;height:auto;">
                  <img
                      src="${img}"
                      alt=""
                      width="40px"
                      height="40px"
                      style="max-width: 100%; height: auto; margin-bottom: .4rem; border-radius: 10%;">
                  <div style="width:75px;height:26px;text-align: left; display: block;">
                      <p style="font-size:1rem; margin: 0; padding:0;">${real_title}</p>
                      <p style="font-size:0.8rem; font-style: italic; margin:0;padding:0;">${description}</p>
                  </div>
              </div>
          `
          } else {
          elem.innerHTML = `
              <div style="width:auto;height:auto;">
                  <img
                      src="${img}"
                      alt=""
                      width="40px"
                      height="40px"
                      style="max-width: 100%; height: auto; margin-bottom: .4rem; border-radius: 10%;">
                  <div style="width:70px;height:26px;text-align: left; display:inline-block;">
                      <p style="font-size:1rem; margin: 0; padding:0;">${real_title}</p>
                      <p style="font-size:0.8rem; font-style: italic; margin:0;padding:0;">${description}</p>
                  </div>
              </div>
          `
            }
      }
    if (elem.textContent.includes('#')) {
        const title = elem.textContent.split('#')[0].replace(/[\n\r]+|[\s]{2,}/g, ' ').trim()
        const img = elem.textContent.split('#')[1].replace(/[\n\r]+|[\s]{2,}/g, ' ').trim()
        elem.innerHTML = `
            <div style="margin-left:0;">
            <img
                src="${img}"
                alt=""
                width="12px"
                height="12px"
                style="max-width: 100%; height: auto;">
            <div style="text-align: left; font-size: 1rem; display: inline-block; overflow-x: visible;">
                ${title}
            </div>
            </div>
        `
    }
})
